import { create } from './create';
import { get, getRaw } from './get';
import { list } from './list';
import { patch, patchRaw } from './patch';
import { validate, validateRaw } from './validate';

export { type PatchSchemaPayload } from './patch';

/**
 * @noSchema
 */
type Schemas = {
  get: typeof get;
  getRaw: typeof getRaw;
  create: typeof create;
  list: typeof list;
  patch: typeof patch;
  patchRaw: typeof patchRaw;
  validate: typeof validate;
  validateRaw: typeof validateRaw;
};

export const schemas: Schemas = {
  get,
  create,
  list,
  patch,
  validate,
  getRaw,
  validateRaw,
  patchRaw,
};
